import { useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import DirectMessages from '../components/DirectMessages'

export default function Messages() {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()
  
  const selectedConversationId = searchParams.get('conversation')

  if (!isLoggedIn) {
    return (
      <div className="messages-page">
        <div className="container">
          <div className="auth-required">
            <h1>Login Required</h1>
            <p>You must be logged in to access your messages.</p>
            <button 
              onClick={() => navigate('/login')}
              className="btn-primary"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    )
  }

  const handleConversationSelect = (conversationId: string) => {
    setSearchParams({ conversation: conversationId })
  }

  return (
    <div className="messages-page">
      <div className="container">
        {/* Messages Header */}
        <div className="messages-header-section">
          <div className="header-content">
            <h1>Messages</h1>
            <p>Connect with community members through private messages</p>
          </div>
          
          <div className="header-stats">
            <div className="stat">
              <span className="stat-number">3</span>
              <span className="stat-label">Active Chats</span>
            </div>
            <div className="stat">
              <span className="stat-number">2</span>
              <span className="stat-label">Unread</span>
            </div>
          </div>
        </div>

        <DirectMessages
          selectedConversationId={selectedConversationId || undefined}
          onConversationSelect={handleConversationSelect}
        />
      </div>
    </div>
  )
}